<template>
    <div class="mention-container" v-click-outside="onClickOutside">
        <slot></slot>
        <div
            class="absolute z-30 popupItem mention-popover"
            :style="`top: ${caretPosition.top - 5}px; left: ${caretPosition.left - 10}px`"
            v-show="showPopover"
        >
            <span class="absolute top-0 left-0 w-2 h-2 bg-white transform rotate-45 -mt-1 ml-3 border-gray-300 border-r border-b z-20"></span>
            <template v-if="isLoading">
            <div class="popupItem-list">
              <md-list class="p-0px popover-avatar list-reset">
                <md-list-item class="profile">
                      <div class="md-list-item-text">
                        <div class="text-400-medium">Đang tải dữ liệu!</div>
                      </div>
                    </md-list-item>
              </md-list>
            </div>
            </template>
            <!--  -->
            <template v-else>
                <div class="popupItem-list">
                <md-list class="p-0px popover-avatar list-reset" v-if="displayedItems.length > 0">
                    <md-list-item class="profile" v-for="(item,index) in displayedItems" :key="mentionItemKey(item, index)"
                                    :ref="'mentionItem' + index"
                                    @mousedown.prevent.stop="onMentionMouseDown(index)"
                                    :class="selectedIndex == index ? 'mention-selected' : ''">
                        <md-avatar>
                            <img class="avatar" :src="item.avatar.small_thumb || '/img/profile/avatar.png'">
                        </md-avatar>
                        <div class="md-list-item-text">
                            <div class="text-400-medium mention-username">@{{ item.fullname }}</div>
                            <div class="detail-info" v-if="item.team && item.team.agency && item.team.department">
                                <i class="company-structure background-no-repeat"></i>
                                <div class="ml-5px text-2-line">
                                    <span>{{ item.team.agency }}</span>
                                    <span class="ml-5px" v-if="item.team.department">></span>
                                    <span class="ml-5px" v-if="item.team.department">{{ item.team.department }}</span>
                                </div>
                            </div>
                            <div class="detail-info" v-if="item.team && item.team.team">
                                <span class="material-icons">group</span>
                                <span class="ml-5px">{{ item.team.team }}</span>
                            </div>
                        </div>
                        </md-list-item>
                </md-list>
                <md-list class="p-0px popover-avatar list-reset" v-else>
                    <md-list-item class="profile">
                        <div class="md-list-item-text">
                            <div class="text-400-medium">Không có dữ liệu!</div>
                        </div>
                        </md-list-item>
                </md-list>
                </div>
            </template>
        </div>
      </div>
  </template>

<script>
  import ChatService from "../../../../store/services/ChatService";
  import GroupService from "../../../../store/services/GroupService";
  import {GROUP_CHAT_TYPE} from "@/const/const";

  export default {
    name: 'MentionChat',
    // emits: ['search', 'open', 'close', 'apply'],
    props: {
        group: {
            type: Object,
            default: null,
        },
    },
    data: function() {
      return{
        debugMention: false,
        keys: ['@'],
        items: [],
        placement: 'top-start',
        omitKey: false,
        filteringDisabled: false,
        insertSpace: true,
        mapInsert: null,
        limit: 4,
        key: null,
        oldKey: null,
        searchText: null,
        caretPosition: {
            top: 0,
            left: 0,
        },
        selectedIndex: 0,
        input: null,
        showPopover: false,
        displayedItems: [],
        isLoading: false,
        allTextMentions: [],
        except_users: [],
        param_member: {
          group_id: this.$route.params.messenger_id,
          page: 1,
          per_page: 50,
          keyword: null,
          except: []
        },
        lastLoadedSearchText: null,
        chatGroupSelected: this.$store.state.chat.chatGroupSelected,
        timer: null,
        is_all : true,
        members: [],
        isApplyingMention: false,
        isNavigatingWithArrows: false,
        isDocumentKeyBound: false,
        blurCloseTimer: null,
        mentionLoadSeq: 0
      }
    },
    created(){
        this.debugMention = localStorage.getItem("mention_debug") === "1";
    },
    mounted(){
        // re-read debug flag in case it was set after component created
        this.debugMention = localStorage.getItem("mention_debug") === "1";
        this.input = this.getInput();
        if (localStorage.getItem("mention_debug") === "1") {
            // eslint-disable-next-line no-console
            console.log("[MentionChat] mounted", {
                hasInput: !!this.input,
                chatType: this.chatGroupSelected && this.chatGroupSelected.type,
                hasGroupProp: !!this.group,
            });
        }

        // Always bind to the textarea if present; mention enable/disable is handled by checkKey.
        if (this.input) {
            this.attach();
            this.bindDocumentKeys();
        }

        this.$emit('close');
    },
    updated(){
      if(this.chatGroupSelected.type === "GROUP" || this.group){
        if(!this.searchText){
            // this.displayedItems = this.members;
            // this.getMembersMention();
        }
        const newInput = this.getInput()
        if (newInput !== this.input) {
          this.detach()
          this.input = newInput
          this.attach()
        }

        if(!this.input.value){
          this.param_member.except = [];
          this.except_users = [];
        }
      }
    },
    beforeDestroy(){
      if (this.blurCloseTimer) {
        clearTimeout(this.blurCloseTimer);
        this.blurCloseTimer = null;
      }
      this.unbindDocumentKeys();
      this.detach();
    },
    watch: {
      '$route.params.messenger_id'(to, from) {
        this.param_member.group_id = to;
        this.allTextMentions = [];
        this.members = [];
        this.displayedItems = [];
        this.closeMenu("route-change");
      },
      '$store.state.chat.chatGroupSelected'(newV) {
        this.chatGroupSelected = newV
      },
      showPopover(newVal, oldVal) {
        this.dlog("watch showPopover", { oldVal, newVal, key: this.key, searchText: this.searchText });
      },
      key(newVal, oldVal) {
        this.dlog("watch key", { oldVal, newVal, showPopover: this.showPopover, searchText: this.searchText });
      }
    },
    methods: {
        dlog(...args) {
            // allow toggling without reload
            this.debugMention = this.debugMention || localStorage.getItem("mention_debug") === "1";
            if (!this.debugMention) return;
            // eslint-disable-next-line no-console
            console.log("[MentionChat]", ...args);
        },
        bindDocumentKeys() {
            if (this.isDocumentKeyBound) return;
            this.isDocumentKeyBound = true;
            document.addEventListener("keydown", this.onDocumentKeyDown, true);
            if (localStorage.getItem("mention_debug") === "1") {
                // eslint-disable-next-line no-console
                console.log("[MentionChat] bindDocumentKeys()");
            }
            this.dlog("bindDocumentKeys()");
        },
        unbindDocumentKeys() {
            if (!this.isDocumentKeyBound) return;
            this.isDocumentKeyBound = false;
            document.removeEventListener("keydown", this.onDocumentKeyDown, true);
            this.dlog("unbindDocumentKeys()");
        },
        onDocumentKeyDown(e) {
            if (localStorage.getItem("mention_debug") === "1" && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
                // eslint-disable-next-line no-console
                console.log("[MentionChat] document arrow", {
                    key: e.key,
                    keyCode: e.keyCode,
                    showPopover: this.showPopover,
                    keyChar: this.key,
                });
            }
            if (!this.showPopover || !this.key) return;
            this.dlog("document keydown", { key: e.key, keyCode: e.keyCode, showPopover: this.showPopover, keyChar: this.key });
            const code = e.keyCode;
            const key = e.key;
            const isNav =
                key === "ArrowDown" ||
                key === "ArrowUp" ||
                key === "Enter" ||
                key === "Tab" ||
                key === "Escape" ||
                code === 40 ||
                code === 38 ||
                code === 13 ||
                code === 9 ||
                code === 27;
            if (!isNav) return;

            // Handle in mention logic and block all other listeners.
            this.onKeyDown(e);
        },
        updateDisplayedItems: function() {
            this.loadData(!this.searchText);
        },
        mentionItemKey(item, index) {
            if (item && item.id != null) {
                return 'mention-' + item.id;
            }
            if (item && item.value === 'All') {
                return 'mention-all';
            }
            return 'mention-idx-' + index;
        },
        scrollSelectedMentionIntoView() {
            this.$nextTick(() => {
                const ref = this.$refs['mentionItem' + this.selectedIndex];
                const el = Array.isArray(ref) ? ref[0] : ref;
                if (el && typeof el.$el !== 'undefined' && el.$el) {
                    el.$el.scrollIntoView({ block: 'nearest' });
                } else if (el && el.scrollIntoView) {
                    el.scrollIntoView({ block: 'nearest' });
                }
            });
        },
        //
        isIe: function() {
            const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
            return userAgent.indexOf('MSIE ') !== -1 || userAgent.indexOf('Trident/') !== -1;
        },
        isFirefox: function() {
            return !(window.mozInnerScreenX == null);
        },
        setInput: function(el) {
            this.input = el;
        },
        getCaretPosition: function(element, position) {
            let mirrorDiv, computed, style;
            // The properties that we copy into a mirrored div.
            // Note that some browsers, such as Firefox,
            // do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
            // so we have to do every single property specifically.
            var properties = [
                'boxSizing',
                'width', // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
                'height',
                'overflowX',
                'overflowY', // copy the scrollbar for IE

                'borderTopWidth',
                'borderRightWidth',
                'borderBottomWidth',
                'borderLeftWidth',

                'paddingTop',
                'paddingRight',
                'paddingBottom',
                'paddingLeft',

                // https://developer.mozilla.org/en-US/docs/Web/CSS/font
                'fontStyle',
                'fontVariant',
                'fontWeight',
                'fontStretch',
                'fontSize',
                'lineHeight',
                'fontFamily',

                'textAlign',
                'textTransform',
                'textIndent',
                'textDecoration', // might not make a difference, but better be safe

                'letterSpacing',
                'wordSpacing'
            ];
            // mirrored div
            mirrorDiv = document.getElementById(element.nodeName + '--mirror-div');
            if (!mirrorDiv) {
                mirrorDiv = document.createElement('div');
                mirrorDiv.id = element.nodeName + '--mirror-div';
                document.body.appendChild(mirrorDiv);
            }

            style = mirrorDiv.style;
            computed = getComputedStyle(element);

            // default textarea styles
            style.whiteSpace = 'pre-wrap';
            if (element.nodeName !== 'INPUT')
                style.wordWrap = 'break-word'; // only for textarea-s

            // position off-screen
            style.position = 'absolute'; // required to return coordinates properly
            style.top = element.offsetTop + parseInt(computed.borderTopWidth) + 'px';
            style.left = "400px";
            style.visibility = 'hidden'; // not 'display: none' because we want rendering

            // transfer the element's properties to the div
            properties.forEach(function(prop) {
                style[prop] = computed[prop];
            });

            if (this.isFirefox()) {
                style.width = parseInt(computed.width) - 2 + 'px' // Firefox adds 2 pixels to the padding - https://bugzilla.mozilla.org/show_bug.cgi?id=753662
                // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
                if (element.scrollHeight > parseInt(computed.height))
                    style.overflowY = 'scroll';
            } else {
                style.overflow = 'hidden'; // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
            }

            mirrorDiv.textContent = element.value.substring(0, position);
            // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
            if (element.nodeName === 'INPUT')
                mirrorDiv.textContent = mirrorDiv.textContent.replace(/\s/g, "\u00a0");

            var span = document.createElement('span');
            // Wrapping must be replicated *exactly*, including when a long word gets
            // onto the next line, with whitespace at the end of the line before (#7).
            // The  *only* reliable way to do that is to copy the *entire* rest of the
            // textarea's content into the <span> created at the caret position.
            // for inputs, just '.' would be enough, but why bother?
            span.textContent = element.value.substring(position) || '.'; // || because a completely empty faux span doesn't render at all
            mirrorDiv.appendChild(span);

            var coordinates = {
                top: span.offsetTop + parseInt(computed['borderTopWidth']) - element.scrollTop,
                left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
            };
            return coordinates;
        },
        onInput: function() {
            this.checkKey()
        },
        onClickOutside: function() {
            if (!this.showPopover) {
                return;
            }
            if (this.isApplyingMention || this.isNavigatingWithArrows || this.isLoading) {
                this.dlog("onClickOutside ignored", { isApplyingMention: this.isApplyingMention, isLoading: this.isLoading });
                return;
            }
            this.closeMenu("click-outside");
        },
        clearPendingCloseTimers() {
            if (this.blurCloseTimer) {
                clearTimeout(this.blurCloseTimer);
                this.blurCloseTimer = null;
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },
        onMentionMouseDown: function(itemIndex) {
            this.isApplyingMention = true;
            this.applyMention(itemIndex);
            setTimeout(() => {
                this.isApplyingMention = false;
            }, 0);
        },
        onKeyDown: function(e) {
            // this.timer = setTimeout(() => {
                if (this.key) {
                this.dlog("textarea keydown", { key: e.key, keyCode: e.keyCode, showPopover: this.showPopover, searchText: this.searchText });
                if( this.keys.includes(e.key) ) {
                    this.closeMenu("pressed-trigger-key")
                    // return this.cancelEvent(e);
                }
                // this.updateDisplayedItems();
                if (e.key === 'ArrowDown' || e.keyCode === 40) {
                      if (this.displayedItems.length === 0) {
                          return;
                      }
                      this.isNavigatingWithArrows = true;
                      this.selectedIndex++;
                      if (this.selectedIndex >= this.displayedItems.length) {
                          this.selectedIndex = 0;
                      }
                      this.scrollSelectedMentionIntoView();
                      this.cancelEvent(e);
                      if (this.input) this.input.focus();
                      setTimeout(() => {
                          this.isNavigatingWithArrows = false;
                      }, 0);
                  }
                  if (e.key === 'ArrowUp' || e.keyCode === 38) {
                      if (this.displayedItems.length === 0) {
                          return;
                      }
                      this.isNavigatingWithArrows = true;
                      this.selectedIndex--;
                      if (this.selectedIndex < 0) {
                          this.selectedIndex = this.displayedItems.length - 1;
                      }
                      this.scrollSelectedMentionIntoView();
                      this.cancelEvent(e);
                      if (this.input) this.input.focus();
                      setTimeout(() => {
                          this.isNavigatingWithArrows = false;
                      }, 0);
                  }
                  if ((e.key === 'Enter' || e.key === 'Tab' || e.keyCode === 13 || e.keyCode === 9) &&
                      this.displayedItems.length > 0) {
                      this.showPopover = false;
                      this.applyMention(this.selectedIndex)
                      this.cancelEvent(e)
                  }
                  if (e.key === 'Escape' || e.keyCode === 27) {
                      this.closeMenu("escape")
                      this.cancelEvent(e)
                  }
            }
            // }, 500);
        },
        onKeyUp: function(e) {
            if (this.cancelKeyUp && (e.key === this.cancelKeyUp || e.keyCode === this.cancelKeyCode)) {
                this.cancelEvent(e)
            }
            this.cancelKeyUp = null
            // IE
            this.cancelKeyCode = null
        },
        cancelEvent: function(e) {
            e.preventDefault()
            e.stopPropagation()
            if (typeof e.stopImmediatePropagation === 'function') {
                e.stopImmediatePropagation()
            }
            this.cancelKeyUp = e.key
            // IE
            this.cancelKeyCode = e.keyCode
        },
        onScroll: function() {
            this.updateCaretPosition()
        },
        getSelectionStart: function() {
            return this.input.selectionStart
        },
        setCaretPosition: function(index) {
            this.$nextTick(() => {
                if (!this.input) return;
                const pos = Math.max(0, Math.min(index, this.input.value.length));
                this.input.selectionStart = pos;
                this.input.selectionEnd = pos;
                this.input.focus();
            });
        },
        getValue: function() {
            return this.input.value
        },
        setValue: function(value) {
            this.input.value = value;
            this.input.dispatchEvent(
                typeof InputEvent !== "undefined"
                    ? new InputEvent("input", { bubbles: true, cancelable: true })
                    : new Event("input", { bubbles: true }),
            );
        },
        checkKey: function() {
            const input = this.getInput();
            if (!input) {
                return false;
            }
            const index = input.selectionStart;
            const canMention = index >= 0 && (this.chatGroupSelected.type === 'GROUP' || this.group);
            if (!canMention) {
                this.closeMenu("checkKey:cannot-mention");
                return false;
            }

            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.timer = setTimeout(() => {
                const liveInput = this.getInput();
                if (!liveInput) {
                    return;
                }
                const liveIndex = liveInput.selectionStart;
                const { key, keyIndex } = this.getLastKeyBeforeCaret(liveIndex);
                this.dlog("checkKey tick", { index: liveIndex, key, keyIndex, value: liveInput.value });

                // No trigger key before caret => close menu.
                if (keyIndex === -1) {
                    this.closeMenu("checkKey:no-trigger");
                    return;
                }

                // Only trigger if start-of-line or whitespace before '@'
                if (!(keyIndex < 1 || /\s/.test(this.getValue()[keyIndex - 1]))) {
                    this.closeMenu("checkKey:not-after-space");
                    return;
                }

                const searchText = (this.lastSearchText = this.getLastSearchText(liveIndex, keyIndex));
                if (searchText == null) {
                    this.closeMenu("checkKey:searchText-null");
                    return;
                }

                this.openMenu(key, keyIndex);
                this.searchText = searchText;
                this.updateDisplayedItems();
            }, 250);

            return true;
        },
        getLastKeyBeforeCaret: function(caretIndex) {
            const [keyData] = this.keys.map(key => ({
                key,
                keyIndex: this.getValue().lastIndexOf(key, caretIndex - 1),
            })).sort((a, b) => b.keyIndex - a.keyIndex)
            return keyData
        },
        getLastSearchText: function(caretIndex, keyIndex) {
            if (keyIndex !== -1) {
                const searchText = this.getValue().substring(keyIndex + 1, caretIndex);
                if(searchText.split(' ').length < 4){
                 return searchText
                }
                this.$emit('close', null);
            }
            return null
        },
        openMenu: function(key, keyIndex) {
            const canMention = this.group || this.chatGroupSelected.type === 'GROUP';
            if (!canMention) {
                return;
            }

            this.clearPendingCloseTimers();

            if (this.key !== key) {
                this.selectedIndex = 0;
            }
            this.key = key;
            this.keyIndex = keyIndex;
            this.updateCaretPosition();
            this.showPopover = true;
            this.$emit('open', this.allTextMentions);
            this.dlog("openMenu", { key, keyIndex, showPopover: this.showPopover });
        },
        closeMenu: function(reason) {
            if (localStorage.getItem("mention_debug") === "1") {
                // eslint-disable-next-line no-console
                console.log("[MentionChat] closeMenu()", { reason, key: this.key, searchText: this.searchText, showPopover: this.showPopover });
            }
            this.dlog("closeMenu()", { reason, key: this.key, searchText: this.searchText, showPopover: this.showPopover });
            this.mentionLoadSeq++;
            if (this.blurCloseTimer) {
                clearTimeout(this.blurCloseTimer);
                this.blurCloseTimer = null;
            }
            this.oldKey = this.key;
            this.showPopover = false;
            this.isLoading = false;
            this.key = null;
            this.searchText = null;
            if (this.oldKey != null) {
                this.$emit('close', this.oldKey);
            }
            // this.cancelKeyUp = this.cancelKeyCode = null;
        },
        updateCaretPosition: function() {
            if (this.key) {
                this.caretPosition = this.getCaretPosition(this.input, this.keyIndex);
            }
        },
        applyMention: function(itemIndex) {
            const item = this.displayedItems[itemIndex];
            if (!item) {
                return;
            }

            let fullname = item.fullname;

            if(item.id && this.chatGroupSelected.member_count > 30){
              this.except_users.push(item.id);
            }
            // else{
                // this.displayedItems.splice(itemIndex, 1);
            // }
            const value = (this.omitKey ? '' : this.key || '') + String(this.mapInsert ? this.mapInsert(item, this.key) : fullname) + (this.insertSpace ? ' ' : '')
            this.setValue(this.replaceText(this.getValue(), this.searchText, value, this.keyIndex))
            this.setCaretPosition(this.keyIndex + value.length);
            this.$emit("apply", item, this.key, value, this.keyIndex);
            this.closeMenu();
        },
        replaceText: function(text, searchText, newText, index) {
            return text.slice(0, index) + newText + text.slice(index + searchText.length + 1, text.length)
        },

        attach () {
            if (this.input) {
                this.input.addEventListener('input', this.onInput);
                this.input.addEventListener('keyup', this.onKeyUp, true);
                this.input.addEventListener('scroll', this.onScroll);
            }
        },

        detach () {
            if (this.input) {
                this.input.removeEventListener('input', this.onInput);
                this.input.removeEventListener('keyup', this.onKeyUp, true);
                this.input.removeEventListener('scroll', this.onScroll);
            }
        },

        getInput(){
            return this.$el.querySelector('textarea');
        },

        extractMentionList(res) {
            if (!res) {
                return [];
            }
            if (Array.isArray(res)) {
                return res;
            }
            if (Array.isArray(res.data)) {
                return res.data;
            }
            return [];
        },
        buildDisplayedMembers(list) {
            const members = Array.isArray(list) ? list.slice() : [];
            if (!this.searchText) {
                this.members = members;
                return [{
                    value: 'All',
                    fullname: 'Tất cả',
                    department: {
                        name: '• Báo cho cả nhóm •'
                    },
                    avatar: {
                        url: '/img/chat/ic_mention.svg',
                        small_thumb: '/img/chat/ic_mention.svg'
                    }
                }].concat(members);
            }
            return members;
        },
        async loadData(onLoad = true, emit = true) {
            const loadSeq = ++this.mentionLoadSeq;
            this.is_all = true;
            this.isLoading = true;

            const normalizedSearch = (this.searchText || '').trim();
            if (this.lastLoadedSearchText !== normalizedSearch) {
                this.selectedIndex = 0;
                this.lastLoadedSearchText = normalizedSearch;
            }

            const useMentionApi = this.group
                || (this.chatGroupSelected && this.chatGroupSelected.type === 'GROUP');

            this.dlog("loadData.start", { loadSeq, normalizedSearch, showPopover: this.showPopover, groupId: this.param_member.group_id });

            try {
                if (useMentionApi) {
                    this.param_member.keyword = normalizedSearch || null;
                    this.param_member.except = this.except_users.length > 0 ? this.except_users : [];
                    const list = await this.fetchMembersMention();
                    this.dlog("loadData.fetched", { loadSeq, count: list.length, showPopover: this.showPopover, mentionLoadSeq: this.mentionLoadSeq });
                    if (loadSeq !== this.mentionLoadSeq) {
                        return;
                    }
                    if (!this.showPopover) {
                        return;
                    }
                    this.displayedItems = this.buildDisplayedMembers(list);
                } else if (normalizedSearch) {
                    const finalSearchText = normalizedSearch.toLowerCase();
                    const source = this.members.length > 0 ? this.members : this.displayedItems;
                    this.displayedItems = source.filter((elm) => {
                        const fullname = String(elm.fullname || '').toLowerCase();
                        const username = String(elm.username || '').toLowerCase();
                        const displayName = String(elm.display_name || '').toLowerCase();
                        return fullname.includes(finalSearchText)
                            || username.includes(finalSearchText)
                            || displayName.includes(finalSearchText);
                    });
                } else if (!normalizedSearch) {
                    this.displayedItems = this.buildDisplayedMembers(this.members);
                }

                if (loadSeq !== this.mentionLoadSeq || !this.showPopover) {
                    return;
                }

                if (this.selectedIndex >= this.displayedItems.length) {
                    this.selectedIndex = Math.max(0, this.displayedItems.length - 1);
                }

                for (let i = 0; i < this.displayedItems.length; i++) {
                    const text = '@' + this.displayedItems[i]['fullname'];
                    if (!this.allTextMentions.includes(text)) {
                        this.allTextMentions.push(text);
                    }
                }
                if (emit) {
                    this.$emit('open', this.allTextMentions);
                }
                this.dlog("loadData.done", { loadSeq, displayed: this.displayedItems.length });
            } catch (err) {
                this.dlog("loadData.error", err);
            } finally {
                if (loadSeq === this.mentionLoadSeq) {
                    this.isLoading = false;
                }
            }
        },

        async fetchMembersMention() {
            if (this.group) {
                this.param_member.group_id = this.group.id;
                const res = await GroupService.getMemberGroupPost(this.param_member);
                return this.extractMentionList(res);
            }

            const routeGroupId = this.$route && this.$route.params
                ? this.$route.params.messenger_id
                : null;
            if (routeGroupId) {
                this.param_member.group_id = routeGroupId;
            }

            const res = await ChatService.getMembersMention(this.param_member);
            return this.extractMentionList(res);
        },

        highlightTextarea() {
            $(this.input).highlightTextarea({
                words: [{color: "rgb(204,227,255)", words: this.allTextMentions}],
                caseSensitive: false,
            });
            $(this.input).focus();
        },
    }
  }
  </script>

  <style lang="scss">
  .mention-container{
    position: relative;

    .md-avatar {
      flex-shrink: 0;
      overflow: hidden;
      border-radius: 50%;

      img.avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        display: block;
      }
    }

    .popupItem{
        position: absolute;
        z-index: 50;
        &.mention-popover {
            display: block;
        }
        .popupItem-list{
            position: absolute;
            z-index: 10;
            bottom: 100%;
            background: #fff;
            padding: 10px 0;
            border-radius: 5px;
            border: 1px solid rgba(209,213,219,1);
            max-height: 280px;
            overflow-y: auto;
            ul{
                list-style: none;
                margin: 0;
                padding: 0;
              li {
                margin: 0;
                min-width: 320px;
                .md-ripple {
                  padding: 4px 12px 4px 6px !important;
                }
                .mention-username {
                  color: #2145a2;
                  margin-bottom: 1px;
                }
              }
            }
        }
    }
    .detail-info{
        display: flex;
        margin-bottom: 2px;
        font-size: 11px;
        color: #1d1d1d;
        align-items: center;
        span{
            font-size: 11px;
        }
        .company-structure{
            background: url('/img/sidebar/left/department_normal.svg') no-repeat;
            height: 14px;
            width: 14px;
            background-size: 14px;
            justify-content: center;
        }
        .material-icons{
            font-size: 15px;
            color: #808080;
            width: max-content;
        }
    }
    .mention-selected {
      background: #E0E0E0 !important;
    }
  }
  </style>
